module.exports = __webpack_public_path__ + "static/media/CornerCut_After.4452df79.jpg";